module.exports = __webpack_public_path__ + "img/canada.9ad493a3.png";